import store from '../store/store';
import Security from '@/security';

/**
 *   funzione che controlla il premesso per accedere a determinate funzioni,
 *   passare come parametri 'next' (per manipolare la navigazione)
 *   e il ruolo utente che può accedere alla funzionalità
 **/
function checkPermissions(next, roles) {
  let allowed = false;
  if (store.getters.isLogged) {
    roles.forEach((role) => {
      if (store.getters.checkRole == role || store.getters.checkRole == Security.ruolo.ADMIN) {
        allowed = true;
        next();
      }
    });
    if (!allowed) {
      store.dispatch('unauthorized');
    }
  } else {
    store.dispatch('logout');
    next(false);
  }
}

export default [
  {
    path: '*',
    meta: {
      public: true,
    },
    redirect: {
      path: '/404',
    },
  },
  {
    path: '/404',
    meta: {
      public: true,
    },
    name: 'NotFound',
    component: () => import(`@/pages/NotFound.vue`),
  },
  {
    path: '/403',
    meta: {
      public: true,
    },
    name: 'AccessDenied',
    component: () => import(`@/pages/Deny.vue`),
  },
  {
    path: '/DenyApp',
    meta: {
      public: true,
    },
    name: 'AccessDenied',
    component: () => import(`@/pages/DenyApp.vue`),
  },
  {
    path: '/500',
    meta: {
      public: true,
    },
    name: 'ServerError',
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy" */
        `@/pages/Error.vue`
      ),
  },
  {
    path: '/',
    meta: {},
    name: 'Home',
    component: () => import('@/pages/Home.vue'),
    beforeEnter: (to, from, next) => {
      if (store.getters.isLogged) {
        next();
      } else {
        store.dispatch('logout');
        next(false);
      }
    },
  },
  {
    path: '/PrivacyPolicy',
    meta: {},
    name: 'Home',
    component: () => import('@/pages/PrivacyPolicy.vue'),
  },
  {
    path: '/login',
    meta: {
      public: true,
    },
    name: 'Login',
    component: () => import('@/pages/Login.vue'),
  },
  {
    path: '/albo',
    meta: {
      public: true,
    },
    name: 'albo',
    component: () => import(`@/pages/anagrafica/albo/Albo.vue`),
  },
  {
    path: '/calendario',
    meta: {
      public: true,
    },
    name: 'Calendario',
    component: () => import(`@/pages/eventi/calendario/EventiView.vue`),
  },
  {
    path: '/anagrafica/rinnovi',
    meta: {
      breadcrumb: true,
    },
    name: 'anagrafica/rinnovi',
    component: () => import(`@/pages/anagrafica/associati/RinnovoIscrizioni.vue`),
    beforeEnter: (to, from, next) => {
      checkPermissions(next, [Security.ruolo.UTENTE_AMMINISTRATIVO]);
    },
  },

  {
    path: '/anagrafica/rubrica',
    meta: {
      breadcrumb: true,
    },
    name: 'anagrafica/rubrica',
    component: () => import(`@/pages/anagrafica/rubricaGenerale/Rubrica.vue`),
    beforeEnter: (to, from, next) => {
      checkPermissions(next, [Security.ruolo.UTENTE_AMMINISTRATIVO]);
    },
  },
  {
    path: '/anagrafica/albo-giudici',
    meta: {
      breadcrumb: true,
    },
    name: 'anagrafica/albo-giudici',
    component: () => import(`@/pages/anagrafica/alboGiudici/AlboGiudici.vue`),
    beforeEnter: (to, from, next) => {
      checkPermissions(next, [Security.ruolo.UTENTE_AMMINISTRATIVO, Security.ruolo.ASSOCIATO, Security.ruolo.VIEWER, Security.ruolo.RESPONSABILE_ASSOCIAZIONE]);
    },
  },
  {
    path: '/anagrafica/albo-istruttori',
    meta: {
      breadcrumb: true,
    },
    name: 'anagrafica/albo-istruttori',
    component: () => import(`@/pages/anagrafica/alboIstruttori/AlboIstruttori.vue`),
    beforeEnter: (to, from, next) => {
      checkPermissions(next, [Security.ruolo.UTENTE_AMMINISTRATIVO, Security.ruolo.ASSOCIATO, Security.ruolo.VIEWER, Security.ruolo.RESPONSABILE_ASSOCIAZIONE]);
    },
  },
  {
    path: '/anagrafica/associazioni',
    meta: {
      breadcrumb: true,
    },
    name: 'anagrafica/associazioni',
    component: () => import(`@/pages/anagrafica/associazioni/Associazioni.vue`),
    beforeEnter: (to, from, next) => {
      checkPermissions(next, [Security.ruolo.UTENTE_AMMINISTRATIVO, Security.ruolo.ASSOCIATO, Security.ruolo.VIEWER, Security.ruolo.RESPONSABILE_ASSOCIAZIONE]);
    },
  },
  {
    path: '/anagrafica/associazioni/:id',
    meta: {
      breadcrumb: true,
    },
    name: 'anagrafica/associazione',
    component: () => import(`@/pages/anagrafica/associazioni/AssociazioneForm.vue`),
    beforeEnter: (to, from, next) => {
      if (store.getters.isLogged) {
        next();
      } else {
        store.dispatch('logout');
        next(false);
      }
    },
  },
  {
    path: '/anagrafica/associazioni/:idAssociazione/associati',
    meta: {
      breadcrumb: true,
    },
    name: 'anagrafica/associazione/associati',
    component: () => import(`@/pages/anagrafica/associati/Associati.vue`),
    beforeEnter: (to, from, next) => {
      checkPermissions(next, [Security.ruolo.UTENTE_AMMINISTRATIVO, Security.ruolo.ASSOCIATO, Security.ruolo.VIEWER, Security.ruolo.RESPONSABILE_ASSOCIAZIONE]);
    },
  },
  {
    path: '/anagrafica/associati',
    meta: {
      breadcrumb: true,
    },
    name: 'anagrafica/associati',
    component: () => import(`@/pages/anagrafica/associati/Associati.vue`),
    beforeEnter: (to, from, next) => {
      checkPermissions(next, [Security.ruolo.UTENTE_AMMINISTRATIVO, Security.ruolo.ASSOCIATO, Security.ruolo.VIEWER, Security.ruolo.RESPONSABILE_ASSOCIAZIONE]);
    },
  },
  {
    path: '/eventi/calendario',
    meta: {
      breadcrumb: true,
    },
    name: 'eventi/calendario',
    component: () => import(`@/pages/eventi/calendario/Eventi.vue`),
    beforeEnter: (to, from, next) => {
      checkPermissions(next, [Security.ruolo.UTENTE_AMMINISTRATIVO, Security.ruolo.ASSOCIATO, Security.ruolo.VIEWER, Security.ruolo.RESPONSABILE_ASSOCIAZIONE]);
    },
  },
  {
    path: '/eventi',
    meta: {
      breadcrumb: true,
    },
    name: 'eventi',
    component: () => import(`@/pages/eventi/calendario/Eventi.vue`),
    beforeEnter: (to, from, next) => {
      checkPermissions(next, [Security.ruolo.UTENTE_AMMINISTRATIVO, Security.ruolo.ASSOCIATO, Security.ruolo.VIEWER, Security.ruolo.RESPONSABILE_ASSOCIAZIONE]);
    },
  },
  {
    path: '/eventi/calendario/iscrizioni/:idEvento/:idAnnoSportivo',
    meta: {
      breadcrumb: true,
    },
    name: 'eventi/calendario/iscrizioni',
    component: () => import(`@/pages/eventi/iscrizione/IscrizioneEventi.vue`),
    beforeEnter: (to, from, next) => {
      checkPermissions(next, [Security.ruolo.UTENTE_AMMINISTRATIVO, Security.ruolo.ASSOCIATO, Security.ruolo.VIEWER, Security.ruolo.RESPONSABILE_ASSOCIAZIONE]);
    },
  },
  {
    path: '/eventi/showevento/:idEvento',
    name: 'eventi/showevento',
    component: () => import(`@/pages/eventi/EventoApp.vue`),
    beforeEnter: (to, from, next) => {
      checkPermissions(next, [Security.ruolo.UTENTE_AMMINISTRATIVO, Security.ruolo.ASSOCIATO, Security.ruolo.VIEWER, Security.ruolo.RESPONSABILE_ASSOCIAZIONE]);
    },
  },
  {
    path: '/eventi/calendario/:idEvento/:idAnnoSportivo/partecipazioni',
    meta: {
      breadcrumb: true,
    },
    name: 'eventi/calendario/partecipazioni',
    component: () => import(`@/pages/eventi/calendario/PartecipazioniEvento.vue`),
    beforeEnter: (to, from, next) => {
      checkPermissions(next, [Security.ruolo.UTENTE_AMMINISTRATIVO, Security.ruolo.ASSOCIATO, Security.ruolo.VIEWER, Security.ruolo.RESPONSABILE_ASSOCIAZIONE]);
    },
  },

  {
    path: '/eventi/calendario/:idEvento/classifica',
    meta: {
      breadcrumb: true,
    },
    name: 'eventi/calendario/classifica',
    component: () => import(`@/pages/eventi/calendario/ClassificaEvento.vue`),
    beforeEnter: (to, from, next) => {
      checkPermissions(next, [Security.ruolo.UTENTE_AMMINISTRATIVO, Security.ruolo.ASSOCIATO, Security.ruolo.VIEWER, Security.ruolo.RESPONSABILE_ASSOCIAZIONE]);
    },
  },

  {
    path: '/eventi/dettagliGare',
    meta: {
      breadcrumb: true,
    },
    name: 'eventi/dettagliGare',
    component: () => import(`@/pages/eventi/dettagliGare.vue`),
    beforeEnter: (to, from, next) => {
      checkPermissions(next, [Security.ruolo.UTENTE_AMMINISTRATIVO, Security.ruolo.ASSOCIATO, Security.ruolo.VIEWER, Security.ruolo.RESPONSABILE_ASSOCIAZIONE]);
    },
  },
  {
    path: '/eventi/classificagenerale',
    meta: {
      breadcrumb: true,
    },
    name: 'eventi/classificagenerale',
    component: () => import(`@/pages/eventi/classificagenerale.vue`),
    beforeEnter: (to, from, next) => {
      checkPermissions(next, [Security.ruolo.UTENTE_AMMINISTRATIVO, Security.ruolo.ASSOCIATO, Security.ruolo.VIEWER, Security.ruolo.RESPONSABILE_ASSOCIAZIONE]);
    },
  },
  {
    path: '/eventi/ranking',
    meta: {
      breadcrumb: true,
    },
    name: 'eventi/ranking',
    component: () => import(`@/pages/eventi/Ranking.vue`),
  },
  {
    path: '/gestione/notifiche',
    meta: {
      breadcrumb: true,
    },
    name: 'gestione/notifiche',
    component: () => import(`@/pages/gestione/Notifiche.vue`),
    beforeEnter: (to, from, next) => {
      checkPermissions(next, [Security.ruolo.UTENTE_AMMINISTRATIVO]);
    },
  },
  {
    path: '/gestione/in-sospeso',
    meta: {
      breadcrumb: true,
    },
    name: 'gestione/in-sospeso',
    component: () => import(`@/pages/gestione/InSospeso.vue`),
    beforeEnter: (to, from, next) => {
      checkPermissions(next, [Security.ruolo.UTENTE_AMMINISTRATIVO]);
    },
  },
  {
    path: '/gestione/utenti',
    meta: {
      breadcrumb: true,
    },
    name: 'gestione/utenti',
    component: () => import(`@/pages/gestione/Utenti.vue`),
    beforeEnter: (to, from, next) => {
      checkPermissions(next, [Security.ruolo.UTENTE_AMMINISTRATIVO]);
    },
  },
  {
    path: '/gestione/csain',
    meta: {
      breadcrumb: true,
    },
    name: 'gestione/csain',
    component: () => import(`@/pages/gestione/Csain.vue`),
    beforeEnter: (to, from, next) => {
      checkPermissions(next, [Security.ruolo.UTENTE_AMMINISTRATIVO]);
    },
  },
  {
    path: '/notifiche/notificheUtente',
    meta: {
      breadcrumb: true,
    },
    name: 'notifiche/notificheUtente',
    component: () => import(`@/pages/notifiche/NotificheUtente.vue`),
  },
  {
    path: '/loginToken/:token/:page/:access',
    meta: {},
    name: 'loginToken',
    component: () => import(`@/pages/LoginToken.vue`),
  },
];
